<script lang="ts">
  // ============================================================
  // ⚠️ Svelte 4 Legacy Mode Component
  // ------------------------------------------------------------
  // @inertiajs/svelte 호환성을 위해 Svelte 4 문법 유지
  // ============================================================
  import { onMount } from 'svelte';
  import { loadTheme, applyTheme, persistTheme, type ThemeMode } from '@/lib/theme';

  let isDark = false;
  let mounted = false;

  onMount(() => {
    const mode = loadTheme();
    isDark = mode === 'dark';
    mounted = true;
  });

  function toggleTheme() {
    isDark = !isDark;
    const mode: ThemeMode = isDark ? 'dark' : 'light';
    applyTheme(mode);
    persistTheme(mode);
  }
</script>

{#if mounted}
  <button
    on:click={toggleTheme}
    class="p-2 rounded-xl hover:bg-gray-100 dark:hover:bg-dark-tertiary transition-colors"
    aria-label={isDark ? '라이트 모드로 전환' : '다크 모드로 전환'}
  >
    {#if isDark}
      <!-- Sun icon for light mode -->
      <svg class="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clip-rule="evenodd"/>
      </svg>
    {:else}
      <!-- Moon icon for dark mode -->
      <svg class="w-5 h-5 text-gray-700" fill="currentColor" viewBox="0 0 20 20">
        <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"/>
      </svg>
    {/if}
  </button>
{/if}
